var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "UNITED_KINGDOM_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7311 7.18445L33.8211 0.976471V0.105469H33.0571L20.4121 7.18445H22.7311Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.208 12.9971L33.821 19.4961V18.1971L24.528 12.9971H22.208Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M0.258789 1.59689L10.1928 7.18488H12.5148L0.258789 0.296875V1.59689Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.9878 12.9971L0.258789 19.5691V19.6831H2.37778L14.3098 12.9971H11.9878Z",
    fill: "#BD0034"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M31.5234 0.105469H19.7725V6.68646L31.5234 0.105469Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M14.5848 0.105469H2.88086L14.5848 6.68646V0.105469Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M33.8206 7.18439V2.69238L25.8496 7.18439H33.8206Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33.8206 17.4401V12.9971H25.8496L33.8206 17.4401Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M3.54492 19.6831H14.5849V13.4961L3.54492 19.6831Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M19.7725 19.6831H30.8484L19.7725 13.4961V19.6831Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M0.258789 12.9971V17.6411L8.50778 12.9971H0.258789Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M0.258789 7.1842H8.50778L0.258789 2.5332V7.1842Z",
    fill: "#1A237B"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_58967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 20
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000056399665753246532360000003432069340157879714__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M33.8218 0.105469H0.258789V19.6825H33.8218V0.105469Z",
    fill: "white"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_58967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M15.6228 0.105469V8.34744H0.258789V11.8375H15.6228V19.6835H18.7348V11.8375H33.8208V8.34744H18.7348V0.105469H15.6228Z",
    fill: "#BD0034"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/UNITED_KINGDOM.f8de7ae12baddb02d14bcc495e8c98cc.svg";
export { ForwardRef as ReactComponent };